import Navbar from "../homepage/Navbar/Navbar";
import ContSec from "./contsec";


export default function Contact(){
    return(
        <>
        <Navbar/>
        <ContSec/>
        </>
    )
}